// Centralized UI messages for the toast system (pt-BR)
// Add all user-facing strings here for easier translation and maintenance

/**
 * Centralized UI messages for the toast system (pt-BR).
 * All user-facing strings for easier translation and maintenance.
 */
export const TOAST_MESSAGES = {
  FALLBACK_ERROR_DETAILS: 'Nenhum detalhe do erro fornecido',
  SHOW_DETAILS: 'Mostrar detalhes',
  HIDE_DETAILS: 'Ocultar detalhes',
  ERROR_TITLE: 'Erro',
  SUCCESS_TITLE: 'Sucesso',
  WARNING_TITLE: 'Aviso',
  INFO_TITLE: 'Informação',
}
